import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=55be4d54"
import script from "./TemplatePreview.vue?vue&type=script&lang=js"
export * from "./TemplatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports